import { Component, Input } from '@angular/core';

export interface ShortageItem {
  priority: string;
  plateNo: string;
  time: string;
  liters: string;
  loss: string;
  statusColor: string;
  operator: string
}

@Component({
  selector: 'app-shortage-card',
  templateUrl: './shortage-card.component.html',
  styleUrls: ['./shortage-card.component.scss']
})
export class ShortageCardComponent {


  @Input() items: ShortageItem[] = []


}